import { all, call, put, takeLatest } from 'redux-saga/effects'
import { SignerApi } from '../../api/SignerApi'
import { apiReject } from '../../redux/api/actions'
import { GlobalHandler } from '../../utils/ReduxUtils'
import {
  accountInfoFulfilled,
  accountInfoReject,
  accountInfoRequest,
  envelopeInfoFulfilled,
  envelopeInfoRequest,
  gibApplicationQueryFulfilled,
  gibApplicationQueryRequest,
  userEnvelopeProcessFulfilled,
  userEnvelopeProcessReject,
  userEnvelopeProcessRequest,
} from './actions'
import { ActionTypes } from './types'

function* handleAccountInfoRequest(action: ReturnType<typeof accountInfoRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.getAccountInfo, action.payload),
    false,
  )
  if (response) return yield put(accountInfoFulfilled(response))
  if (error) return yield put(accountInfoReject(error))
}

function* handleUserEnvelopeProcessRequest(action: ReturnType<typeof userEnvelopeProcessRequest>) {
  let request = {
    smartCardInfo: {
      terminalName: action.payload.smartCard.selectedTerminal,
      certificateId: action.payload.smartCard.selectedCertificate!.id,
      pin: action.payload.smartCard.pin,
    },
    envelopeNumber: action.payload.envelopeNumber,
  }

  if (action.payload.activationDate !== undefined) {
    request['activationDate'] = action.payload.activationDate.format('YYYY-MM-DDTHH:mm:ss')
  }

  const { response, error } = yield GlobalHandler(
    call(SignerApi.signAndSendUserEnvelope, action.payload),
    false,
  )
  if (response) {
    return yield put(userEnvelopeProcessFulfilled(response))
  }
  if (error) return yield put(userEnvelopeProcessReject(error))
}

function* handleGibApplicationQueryRequest(action: ReturnType<typeof gibApplicationQueryRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.gibApplicationQuery, action.payload),
    false,
  )
  if (response) return yield put(gibApplicationQueryFulfilled(response.data))
  if (error) {
    return yield put(apiReject(error))
  }
}

function* handleEnvelopeQueryRequest(action: ReturnType<typeof envelopeInfoRequest>) {
  let request = {
    registerNumber: action.payload.smartCard.selectedCertificate!.serialNumber,
    smartCardInfo: {
      terminalName: action.payload.smartCard.selectedTerminal!,
      certificateId: action.payload.smartCard.selectedCertificate!.id,
      pin: action.payload.smartCard.pin,
    },
    envelopeId: action.payload.envelopeId,
  }

  const { response, error } = yield GlobalHandler(
    call(SignerApi.getEnvelopeInfo, action.payload),
    false,
  )
  if (response) {
    return yield put(envelopeInfoFulfilled(response))
  }
}

function* SmartCardSaga() {
  yield all([
    takeLatest(ActionTypes.ACCOUNT_INFO_REQUEST, (action: any) => handleAccountInfoRequest(action)),
    takeLatest(ActionTypes.USER_ENVELOPE_PROCESS_REQUEST, (action: any) =>
      handleUserEnvelopeProcessRequest(action),
    ),
    takeLatest(ActionTypes.GIB_APPLICATION_QUERY_REQUEST, (action: any) =>
      handleGibApplicationQueryRequest(action),
    ),
    takeLatest(ActionTypes.ENVELOPE_QUERY_REQUEST, (action: any) =>
      handleEnvelopeQueryRequest(action),
    ),
  ])
}

export default SmartCardSaga
